<div class="pds-input-select" [formGroup]="formGroup" [class.--disabled]="disable">
  <div class="pds-input-select__select">
    <select formControlName="inputType" (change)="onChangeType()">
      @for (type of types; track type) {
      <option [value]="type.key">{{ type.label }}</option>
      }
    </select>
  </div>

  <input [type]="valueType" (input)="onChange(values)" formControlName="inputValue" />
</div>
